import ClientTypes from '../types/ClientTypes';

const initialState = {
  isLoading: false,
  clientListData: [],
  clientItemData: {},
  companyClientData: [],
  activeClientData: [],
  queryParams: {
    paginationData: { page: 0, pageSize: 10 },
    sortingData: { sortField: '', sort: '' },
    keyword: '',
    department: ''
  }
};

// eslint-disable-next-line default-param-last
const client = (state = initialState, action) => {
  switch (action.type) {
    case ClientTypes.GET_CLIENT_LIST_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ClientTypes.GET_CLIENT_LIST_SUCCESS:
      return {
        ...state,
        isLoading: false,
        clientListData: action.payload
      };
    case ClientTypes.GET_CLIENT_LIST_ERROR:
      return {
        ...state,
        isLoading: false,
        clientListData: []
      };

    case ClientTypes.GET_CLIENT_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ClientTypes.GET_CLIENT_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        clientItemData: action.payload
      };
    case ClientTypes.GET_CLIENT_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        clientItemData: []
      };

    case ClientTypes.GET_COMPANY_CLIENT_ITEM_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ClientTypes.GET_COMPANY_CLIENT_ITEM_SUCCESS:
      return {
        ...state,
        isLoading: false,
        companyClientData: action.payload
      };
    case ClientTypes.GET_COMPANY_CLIENT_ITEM_ERROR:
      return {
        ...state,
        isLoading: false,
        companyClientData: []
      };
    case ClientTypes.GET_CLIENT_ACTIVE_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ClientTypes.GET_CLIENT_ACTIVE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        activeClientData: action.payload
      };
    case ClientTypes.GET_CLIENT_ACTIVE_ERROR:
      return {
        ...state,
        isLoading: false,
        activeClientData: []
      };

    case ClientTypes.UPDATE_CLIENT_QUERY_PARAMS:
      return {
        ...state,
        queryParams: {
          // ...state.queryParams,
          paginationData: action.payload.paginationModel,
          sortingData: action.payload.sortInfo,
          keyword: action.payload.keyword,
          department: action.payload.departmentName
        }
      };
    default:
      return state;
  }
};
export default client;
